import { Link } from "react-router-dom";
import { ReactSVG } from "react-svg";
import asset from "assets/images";
import "./CreateAutomationHeader.scss";

const CreateAutomationHeader = ({ isEdit }) => {
    return (
        <div className='create-automation__heading'>
            <div className='pre__nav padded__layout'>
                <Link to='/t-sam/automations'>Automations</Link>
                <ReactSVG
                    src={asset?.icons?.rightBlack}
                    className='anchor-right'
                />
                <p>{isEdit ? "Edit automation" : "Create automation"}</p>
            </div>
        </div>
    );
};

export default CreateAutomationHeader;
